import React, {PropsWithChildren, useState} from 'react';
import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import useGet from "../hooks/useGet";
import {concepts, User} from "fearless-common";
import CopyText from "./CopyText";

function UserLinkField({ userId }: { userId: number }) {
    const { data } = useGet<{ url?: string }>({ endpoint: `/users/${userId}/complete-account-link` })

    return data?.url ? <CopyText text={data.url} /> : null;
}

export default function UserCard({ user, children, className }: PropsWithChildren<{
    user: Pick<User, 'first_name' | 'last_name' | 'position' | 'group_name' | 'organisation' | 'email'  | 'id'>;
    className?: string;
}>) {
    const [show, setShow] = useState(false);
    const isInvitedUserWithoutCompletedAccount = !user.first_name && !user.last_name;

    return (
        <div
            className={`mb-0 py-2 text-start rounded-0 d-flex justify-content-between align-items-center ${className}`}
        >
            <div>
                <div className="fw-semibold line-height-1-0">
                    {isInvitedUserWithoutCompletedAccount ? (
                        <>
                            <div>{user.email}</div>
                            <Button variant="link" className="px-0 mb-0 py-0 text-sm" onClick={() => setShow(true)}>
                                Show invitation link
                            </Button>
                            {show && (
                                <Modal show onHide={() => setShow(false)}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Invitation link</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <p>Please share this link with your {concepts.Group.toLowerCase()} {concepts.GroupMember.toLowerCase()}.</p>
                                        <UserLinkField userId={user.id} />
                                    </Modal.Body>
                                </Modal>
                            )}
                        </>
                    ) : `${user.first_name} ${user.last_name}`}
                </div>
                <small className="text-sm">
                    {[[user.position, user.group_name, user.organisation].filter(s => s).join(', ')].map((str) => str ? <span key={str}>{str}</span> : null)}
                </small>
            </div>
            <div>
                {children}
            </div>
        </div>
    );
}
